export const logged = state => state.logged

export const role = state => state.role

export const hostAPI = state => state.hostAPI

export const getted_data_0 = state => state.getted_data_0
export const getted_data_1 = state => state.getted_data_1
export const getted_data_2 = state => state.getted_data_2
export const getted_data_3 = state => state.getted_data_3
export const getted_data_4 = state => state.getted_data_4
export const getted_data_5 = state => state.getted_data_5
export const getted_data_6 = state => state.getted_data_6
export const getted_data_7 = state => state.getted_data_7
export const getted_data_8 = state => state.getted_data_8